import React from "react";

import { Input } from "src/common/components/Input";

const noop = (): void => {};

interface NumberInputProps
	extends Omit<
		React.ComponentProps<typeof Input>,
		"value" | "onChangeValue"
	> {
	value?: number | undefined;
	onChangeValue?(value: number | undefined): unknown;
}

export const NumberInput: React.FunctionComponent<NumberInputProps> = ({
	value,
	onChangeValue: onChangeValueOriginal = noop,
	...props
}) => {
	const onChangeValue = React.useCallback(
		(value: string | undefined) => {
			if (value === undefined || value === "") {
				onChangeValueOriginal(undefined);
			} else {
				onChangeValueOriginal(parseFloat(value));
			}
		},
		[onChangeValueOriginal]
	);
	return (
		<Input
			{...props}
			type="number"
			value={value === undefined ? "" : `${value}`}
			onChangeValue={onChangeValue}
		/>
	);
};
